import { useRouter } from 'next/router'
import { Configure } from 'react-instantsearch'

import { isEmpty } from 'lodash'

import { useGetNavMenu } from 'features/layout/header/navbar/use-get-nav-menu'

import { useDynamoDbUserContext } from 'contexts/DynamoDbUserContext'
import { useProductSearchSettings } from 'hooks/product/use-product-search-settings'

import { isEnableAlgoliaAnalytics } from 'utils/search/insights'

import { INSTANT_SEARCH_ATTRIBUTES } from 'constants/instantSearch'
import { ROUTES } from 'constants/routes'

import {
  BESTSELLERS_QUERY,
  DEFAULT_NEW_PRODUCT_DURATION_IN_DAYS,
  NEW_PUBLISHED_QUERY,
} from '../refinement-by-query/constants'
import { FILTER_BOOLEAN_OPERATOR, filterQueryBuilder, getNewProductDurationRange } from './utils'

const HITS_PER_PAGE = 48

const SearchPageConfigure = () => {
  const router = useRouter()
  const { data: navMenuItemList } = useGetNavMenu()
  const { data: productSearchSettings } = useProductSearchSettings()
  const { dynamoDbUser } = useDynamoDbUserContext()

  if (isEmpty(navMenuItemList) || isEmpty(productSearchSettings)) {
    return null
  }
  const numericalQuires: string[] = []
  const facetQueries: string[] = []

  const [nowTimeUnix, newProductDuration] = getNewProductDurationRange(
    productSearchSettings.newProductDurationInDays ?? DEFAULT_NEW_PRODUCT_DURATION_IN_DAYS
  )

  const newFilter = `${INSTANT_SEARCH_ATTRIBUTES.FIRST_PUBLISH_DATE_UNIX.attr} >= ${nowTimeUnix - newProductDuration}`
  const bestSellerFilter = `${INSTANT_SEARCH_ATTRIBUTES.BEST_SELLER.attr} = 1`

  const hasNewQuery = router.query[NEW_PUBLISHED_QUERY.name] === NEW_PUBLISHED_QUERY.queryOnValue
  const hasBestSellerQuery = router.query[BESTSELLERS_QUERY.name] === BESTSELLERS_QUERY.queryOnValue

  switch (true) {
    case router.asPath.includes(ROUTES.SEARCH_PRODUCTS_NEW):
      numericalQuires.push(newFilter)
      break

    case router.asPath.includes(ROUTES.SEARCH_PROMOTION):
      {
        const params = router.query.terms as string[]
        const promotionKey = params[1]
        const promotion = navMenuItemList?.find((nav) => nav.key === promotionKey && nav.tag === 'promotion')
        const promotionKeys = promotion?.categoryNav?.promotion?.brandKeys

        if (promotionKeys) {
          const brandFilters = `(${INSTANT_SEARCH_ATTRIBUTES.BRAND_KEYS.attr}:${promotionKeys.join(
            ` ${FILTER_BOOLEAN_OPERATOR.OR} ${INSTANT_SEARCH_ATTRIBUTES.BRAND_KEYS.attr}:`
          )})`
          facetQueries.push(brandFilters)
        }
      }
      break

    case router.asPath.includes(ROUTES.SEARCH_PRODUCTS_BEST_SELLERS):
      numericalQuires.push(bestSellerFilter)
      break
    default:
      break
  }

  switch (true) {
    case hasNewQuery && hasBestSellerQuery:
      numericalQuires.push(`(${bestSellerFilter} ${FILTER_BOOLEAN_OPERATOR.OR} ${newFilter})`)
      break
    case hasBestSellerQuery:
      numericalQuires.push(bestSellerFilter)
      break
    case hasNewQuery:
      numericalQuires.push(newFilter)
      break
    default:
      break
  }

  const withEnableAnalytics = isEnableAlgoliaAnalytics()

  return (
    <Configure
      hitsPerPage={HITS_PER_PAGE}
      filters={filterQueryBuilder(numericalQuires, facetQueries)}
      clickAnalytics={withEnableAnalytics}
      analytics={withEnableAnalytics}
      userToken={dynamoDbUser?.cognitoUserId ?? undefined}
    />
  )
}

export default SearchPageConfigure
